import { RichText } from '@/components/shared/rich-text'
import { SectionHeader } from '@/components/shared/section-header'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { BlokProps } from '@/lib/types'
import { TestimonialsStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { Quote } from 'lucide-react'
import Image from 'next/image'
import { Container } from '../shared/container'

export function Testimonials({ blok }: BlokProps<TestimonialsStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border border-y"
    >
      <div className="border-border border-b pt-20 pb-16">
        <div className="page-container">
          <SectionHeader
            icon={blok.descriptorIcon}
            title={blok.title}
            preTitle={blok.descriptorTitle}
          ></SectionHeader>
        </div>
      </div>
      <Container className="border-border border-x">
        <div className="bg-border grid grid-cols-1 gap-[1px] lg:grid-cols-3">
          {blok.items?.map((item) => (
            <div
              {...storyblokEditable(item)}
              key={item._uid}
              className="bg-background space-y-6 p-6 lg:px-9 lg:py-16"
            >
              {item.logo?.filename && (
                <Image
                  unoptimized={item.logo.filename.includes('svg')}
                  src={item.logo?.filename}
                  width={300}
                  height={100}
                  className="h-6 w-auto brightness-0 filter dark:brightness-0 dark:invert dark:filter"
                  alt={item.company ?? ''}
                />
              )}
              <div>
                <Quote className="text-muted-foreground h-6"></Quote>
                <RichText content={item.content} />
              </div>
              <div className="flex items-center gap-2.5">
                <Avatar>
                  {item.avatar?.filename && (
                    <AvatarImage
                      src={item.avatar?.filename}
                      className="object-cover object-center"
                      alt={`${item.name} from ${item.company}`}
                    />
                  )}
                  <AvatarFallback>
                    {item.name
                      ?.split(' ')
                      ?.map((p) => p.substring(0, 1))
                      .join('')}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <div className="text-accent-foreground font-medium">{item.name}</div>
                  <div className="text-muted-foreground">
                    {item.role}, {item.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
